// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.warningIcon[data-v-391f4387] {\n  font-size: 14px;\n  margin-left: 10px;\n  color: red;\n}\n", ""]);
// Exports
module.exports = exports;
